import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex } from "@chakra-ui/react";
import '../styles/dsr-display.scss';

import { createNewDsrAction, resetCreateNewDsrAction } from '../actions/dsr-actions';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckFormTextAreaInput from '../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';
import LaunchdeckModalButtonBar from '../../global/components/helper-components/components/LaunchdeckModalButtonBar';


function CreateNewCategoryForm({
  dsrId,
  handleCloseModal,
  createNewDsrActionOutcome,
  createNewDsrAction,
  resetCreateNewDsrAction
}) {

  const titleCharacterLimit = 100;

  // Input management
  const [categoryInput, setCategoryInput] = useState("")
  const [mapDescriptionInput, setMapDescriptionInput] = useState("")

  // Validation for required input
  const [showNoCategoryError, setShowNoCategoryError] = useState(false)

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  const onChangeHandler = (event) => {
    setShowNoCategoryError(false)

    switch (event.target.name) {
      case ('action-category'): {
        setShowNoCategoryError(false)
        setCategoryInput(event.target.value)
        break;
      }
      case ('action-category-description'): {
        setMapDescriptionInput(event.target.value)
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleCloseCreateActionCategoryModal = () => {
    setCategoryInput("")
    setMapDescriptionInput("")

    handleCloseModal()
  }

  const handleCreateNewAction = () => {

    if (categoryInput.trim().length < 1) {
      setShowNoCategoryError(true)
    } else {
      const newActionMetadata = {
        dsrId,
        mapCategoryName: categoryInput?.trim(),
        mapCategoryDescription: mapDescriptionInput?.trim(),
        event: "create-new-category"
      }

      setShowLoader(true)
      createNewDsrAction(newActionMetadata)
    }


  }

  useEffect(() => {
    if (createNewDsrActionOutcome) {
      setShowLoader(false)
      setCategoryInput("")
      setMapDescriptionInput("")
      handleCloseModal()
    }

    resetCreateNewDsrAction()

  }, [createNewDsrActionOutcome, resetCreateNewDsrAction, handleCloseCreateActionCategoryModal]);

  return (
    <Box w="100%" align="center" mt='1em'>
      <Flex direction='column' align='center' gap='1em' px='2em'>
        <LaunchdeckFormInput
          label='Category name'
          name={'action-category'}
          onChange={onChangeHandler}
          value={categoryInput}
          isRequired={true}
          charLimit={titleCharacterLimit}
          isDisabled={showLoader}

          errorLogic={showNoCategoryError}
          errorMessage={`Provide a name for your Category`}
        />

        <LaunchdeckFormTextAreaInput
          label="Category description (optional)"
          name="action-category-description"
          onChange={onChangeHandler}
          value={mapDescriptionInput}
          charLimit={300}
          isDisabled={showLoader}
        />
      </Flex>

      <LaunchdeckModalButtonBar
        fontSize='1em'
        handleCloseModal={handleCloseCreateActionCategoryModal}
        loadingLogic={showLoader}
        ctaFunction={handleCreateNewAction}
        ctaLabel='Create'
        noCancelOption={true}
      />

    </Box>
  )
}


function mapStateToProps(state) {
  return {
    createNewDsrActionOutcome: state.createNewDsrActionOutcome.results.data,
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createNewDsrAction,
      resetCreateNewDsrAction
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateNewCategoryForm));
